/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Finish_Confirm_Warn_TablesInputs */



/**
* | output |
* | --- |
* | "{count} table(s) are unscored or have invalid scores" |
*
* @param {Finish_Confirm_Warn_TablesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_warn_tables = /** @type {((inputs: Finish_Confirm_Warn_TablesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Warn_TablesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} table(s) n'ont pas de score ou ont des scores invalides`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} mesa/s no tienen puntuación o tienen puntuaciones no válidas`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} mesa/s não têm pontuação ou têm pontuações inválidas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} tavolo/i non hanno un punteggio o hanno punteggi non validi`)
	return /** @type {LocalizedString} */ (`${i?.count} table(s) are unscored or have invalid scores`)
});